var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg fullheight",attrs:{"fluid":""}},[_vm._l((_vm.bgImages),function(bgImage,index){return _c('figure',{key:index,style:([{
      backgroundImage: 'url(' + bgImage.url + ')',
      animationDelay: index * (_vm.duration - _vm.transition) + 's'
    }])})}),_vm._v(" "+_vm._s(_vm.bgLength)+" ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }